import React, { useState, useEffect, use } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { oauthClientService } from "../../utils/services/o-auth-client";
import OAuthClientModal from "../../components/oauth-client-modal";
import OAuthClientList from "../../components/oauth-client-list";
import { Box, Button, CircularProgress, IconButton } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";

const OAuthClient = () => {
  const [authData, setAuthData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedAuthData, setSelectedAuthData] = useState(null);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [total, setTotal] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const selectedUser = localStorage.getItem("selected_user");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await oauthClientService.fetch(
        rowsPerPage,
        page * rowsPerPage,
        selectedUser
      );
      setAuthData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Failed to fetch OAuth clients:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, selectedUser]);

  useEffect(() => {
    return () => {
      setAuthData([]);
      setTotal(0);
      setPage(0);
      setRowsPerPage(15);
    };
  }, []);

  return (
    <DashboardContainer
      hideFilterClient
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"OAuth Client List"}
      title={"+ Add OAuth Client"}
      setViewMode={setViewMode}
      filterButton={false}
      headerButtons={
        <>
          <IconButton
            onClick={fetchData}
            style={{ backgroundColor: "primary.main" }}
          >
            <SyncIcon color="primary" />
          </IconButton>
        </>
      }
    >
      <OAuthClientModal
        selectedTemplate={selectedAuthData}
        handleClose={() => {
          setOpenModal(false);
          setSelectedAuthData(null);
        }}
        open={openModal}
        onAddData={fetchData}
        user={selectedUser}
      />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <OAuthClientList
          dataCount={total}
          page={page}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setPage={setPage}
          onDeleteData={fetchData}
          onEditData={(e) => {
            setSelectedAuthData(e);
            setOpenModal(true);
          }}
          data={authData}
          viewMode={viewMode}
          selectedAuthClient={selectedAuthData}
          setSelectedAuthClient={setSelectedAuthData}
        />
      )}
    </DashboardContainer>
  );
};

export default OAuthClient;
